<template>
	<span v-if="releaseDate">
		&middot;
		<span>Deployed: {{ releaseDate }} ({{ releaseHash }})</span>
	</span>
</template>

<script>
import { releaseDate, releaseHash } from "./releaseDate.ts";
import { mapActions } from "vuex";

export default {
	computed: {
		releaseDate() {
			return releaseDate;
		},
		releaseHash() {
			return releaseHash;
		}
	},
	mounted() {
		if (this.releaseDate) {
			this.dataLayerPush({ version: this.releaseDate });
		}
	},
	methods: {
		...mapActions({
			dataLayerPush: "datalayer/push"
		})
	}
};
</script>

<style></style>
